import { type } from '@/utils/type'

export const DATAPOOL_REQUEST = type('DATAPOOL_REQUEST')
export const DATAPOOL_SUCCESS = type('DATAPOOL_SUCCESS')
export const DATAPOOL_ERROR = type('DATAPOOL_ERROR')

export const DATAPOOL_UPDATE_REQUEST = type('DATAPOOL_UPDATE_REQUEST')
export const DATAPOOL_UPDATE_SUCCESS = type('DATAPOOL_UPDATE_SUCCESS')
export const DATAPOOL_UPDATE_ERROR = type('DATAPOOL_UPDATE_ERROR')

export const DATAPOOL_UPDATE = type('DATAPOOL_UPDATE')
export const DATAPOOL_DELETE = type('DATAPOOL_DELETE')
export const DATAPOOL_ENSURE = type('DATAPOOL_ENSURE')

export const DATAPOOL_MSG_ACCUEIL_REQUEST = type('DATAPOOL_MSG_ACCUEIL_REQUEST')
export const DATAPOOL_MSG_ACCUEIL_SUCCESS = type('DATAPOOL_MSG_ACCUEIL_SUCCESS')
export const DATAPOOL_MSG_ACCUEIL_ERROR = type('DATAPOOL_MSG_ACCUEIL_ERROR')
